import copy from 'clipboard-copy';
import React, { useEffect, useMemo, useRef, useState } from "react";
import ReactDOMServer from 'react-dom/server';
import { Tooltip as FieldHintTooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

// import { QRCode } from 'react-qr-svg';
import { QRCodeSVG } from 'qrcode.react';
import Toast from "../../components/Toast";
// import logo from "../components/images/GymLogo.png";
// import logo from "../../components/images/Easy-MembrLogo.png";
import logo from "../../components/images/easybook.png";
import { getGBussinessInfo, getWaiverSettingsbyGymid, updateLocation, getLocation, updateWaiverSettings, getPaymentLinkSetting, reqConfirmPaymentStatus, saveGBussinessInfo, createSubDomain, getAllSubDomain, createRazorpayGateway, logEvent, getClassBookingWaiverSettings } from "../../services/classApiServices.js";
import { getCustomisableCancellation, getCustomisablePrivacy } from "../../services/apiServices.js";
import BusinessPage from "../BusinessPage";
import BussinessHours from "../BussinessHours.js";
import PaymentMethods from "../PaymentMethods.js";
import RazorPayKeys from "../../components/class/RazorPayKeys.js"
import FlexibleCancellationPolicy from '../../components/class/FlexibleCancellationPolicy';
import FlexiblePrivacyPolicy from "../../components/class/FlexiablePrivacyPolicy";
import TaxSettings from "../TaxSettings";
// import WaiverSettings from "./waiverSettings.js";
import WaiverSettings from "../waiverSettings";
import { defaultPolicyContent, defaultPrivacyContent } from "../../utils/DefaultPolicyData";
import { verifyOrderWithKeys, getRazorpayGateway } from "../../services/classApiServices";
import ClassBookingSettings from "../../components/class/ClassBookingSetting.js";
import {
    MDBAlert,
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBCardText,
    MDBCardTitle,
    MDBChip,
    MDBCol,
    MDBIcon,
    MDBInput,
    MDBInputGroup,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalFooter,
    MDBModalHeader,
    MDBModalTitle,
    MDBRadio,
    MDBRow
} from 'mdb-react-ui-kit';
import PageError from '../PageError';
import GeoLocation from '../../components/geolocationfencing.js';
import SideNavClass from './SideNavClass';
import { isMobile } from 'react-device-detect';
import { useLocation, useNavigate } from 'react-router';
import PaymentGateway from '../../components/class/paymentGateway';
import { browserName, browserVersion } from "react-device-detect";

import Announcements from '../../components/Announcements';
import { useAnalytics } from '../../hooks/useAnalytics';
import { useAccess } from '../../context/AccessContext';
// import { createSubDomain, getAllSubDomain } from '../../services/apiServices';

/** Stable ids for react-tooltip (plain strings; safe for HTML id). */
const RAZORPAY_WEBHOOK_URL_HINT_ID = 'classbiz-razorpay-webhook-url-hint';
const RAZORPAY_WEBHOOK_SECRET_HINT_ID = 'classbiz-razorpay-webhook-secret-hint';

const ClassBusinessInfo = () => {
    const { trackButtonClick } = useAnalytics();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    let popup = params.get('value') == "true" ? true : false;
    const navigate = useNavigate();

    const { loading, handlePageAccess, handleClassPageAssess } = useAccess();
    const roleAccess = handleClassPageAssess("businessinfo")


    useEffect(() => {
        if (popup) {
            setBasicModal(true);
            navigate(location.pathname, { replace: true });
        }
    }, [params.get('value')]);
    const [modeOpen, setModeOpen] = useState(true);
    const [mode, setMode] = useState('side');
    const [plansInfo, setPlansInfo] = useState(JSON.parse(localStorage.getItem("planInfo")));
    const [info, setInfo] = useState("");
    console.log("info", info);
    const [smessage, setSMessage] = useState(null);
    const [apiError, setApiError] = useState(false);
    const [PaymentLink, setPaymentLink] = useState();
    const [refresh, setRefresh] = useState(false)
    const [Error2, setError2] = useState("")
    const [digitalWaiverStatus, setDigitalWaiverStatus] = useState(false);
    const [WaiverForm, setWaiverForm] = useState({
        uniqueNumber: "",
        title: "Digital Waiver Form",
        emergencycontact: 2,
        bloodgroup: 2,
        address: 2,
        phone: 1,
        email: 1,
        checkboxcontent: `By checking this box, I acknowledge that I have read, understood, and agree to the terms and conditions
outlined in the waiver form. I accept full responsibility for my participation, or for the participation of the
minor I am legally responsible for, in climbing activities at Crag Studio, and recognize the inherent risks
involved.`,
        agreement:
            `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia
deserunt mollit anim id est laborum`
        ,
    });

    const logourl = (localStorage.getItem("loggedUserInfo") ? (JSON.parse(localStorage.getItem("loggedUserInfo")).gymlogoUrl ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymlogoUrl : logo) : logo)
    const [imageLoaded, setImageLoaded] = useState(true);
    const [geolocation, setGeolocation] = useState({})
    const [userQRCode, setUserQRCode] = useState(false)
    const [razorpayKeyId, setRazorpayKeyId] = useState("");
    const [razorpaySecret, setRazorpaySecret] = useState("");
    /** Mongo _id of razorpaygateway doc (for updates incl. webhook secret) */
    const [razorpayGatewayDocId, setRazorpayGatewayDocId] = useState("");
    /** User pastes Razorpay Dashboard → Webhooks signing secret (not API Key Secret) */
    const [razorpayWebhookSecretInput, setRazorpayWebhookSecretInput] = useState("");
    const [hasRazorpayWebhookSecret, setHasRazorpayWebhookSecret] = useState(false);
    const [originalPaymentMode, setOriginalPaymentMode] = useState("offline");
    const [announceModal, setAnnounceModal] = useState(false)
    console.log("razorpayKeyId", razorpayKeyId);
    console.log("razorpaySecret", razorpaySecret);


    const [paymentComplete, setPaymentComplete] = useState(false);
    const [paymentInfo, setPaymentInfo] = useState(null);
    const [verificationStatus, setVerificationStatus] = useState(null);
    console.log("verificationStatus", verificationStatus);
    const [originalKeyId, setOriginalKeyId] = useState("");
    const [originalSecret, setOriginalSecret] = useState("");


    const [loader, setLoader] = useState(false);
    const [errors, setErrors] = useState(false);
    const [Alerttxt, setAlerttxt] = useState("");

    const [cancellationPolicyDetails, setCancellationPolicyDetails] = useState('');
    const [cancellationPolicyData, setCancellationPolicyData] = useState({
        title: 'Terms and Conditions',
        cancellationPolicy: ''
    });

    console.log("cancellationPolicyData", cancellationPolicyData);

    const [PolicyDetails, setPolicyDetails] = useState('');
    const [privacyPolicyData, setPrivacyPolicyData] = useState({
        title: 'Privacy Policy',
        privacyPolicy: ''
    });

    const [cancellationModal, SetCancellationModal] = useState(false);
    const canCellationModalShow = () => SetCancellationModal(!cancellationModal);

    const [privacyModal, SetPrivacyModel] = useState(false);
    const PrivacyModalShow = () => SetPrivacyModel(!privacyModal);
    const [classSettings, setClassSettings] = useState(false);
    const classSettingsShow = () => setClassSettings(!classSettings);

    const handleDetailsChange = (details) => {
        setCancellationPolicyDetails(details);
    };

    const handleChangeDetails = (details) => {
        setPolicyDetails(details);
    };

    function onbacktoStaff(flag) {
        setError2(flag);

        setTimeout(() => {
            window.location.reload();
        }, 1000);

    }

    const isHtmlEmpty = (html) => {
        if (!html) return true;
        const textContent = html.replace(/<[^>]*>/g, '').trim();
        return textContent === '';
    };


    const gymId = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;

    const classApiPublicBase = useMemo(() => {
        if (typeof window === "undefined") return "";
        const env = process.env.REACT_APP_PRIMARY_SERVER_URL;
        if (env && typeof env === "string" && /^https?:\/\//i.test(env)) {
            return env.replace(/\/?$/, "/");
        }
        const host = window.location.hostname;
        if (host === "localhost" || host === "127.0.0.1") {
            return `${window.location.protocol}//${host}:${window.location.port || "5000"}/api/`;
        }
        return `${window.location.origin}/api/`;
    }, []);

    const razorpayWebhookUrl =
        gymId && classApiPublicBase ? `${classApiPublicBase}razorpay/webhook/${gymId}` : "";

    const fetchCancellationPolicy = async () => {
        try {
            const response = await getCustomisableCancellation(gymId);
            if (!response || response === "false") {
                setCancellationPolicyData({
                    title: 'Terms and Conditions',
                    cancellationPolicy: defaultPolicyContent
                });
                return;
            }

            const result = await response.json();
            if (result) {
                const policyDetails = result.cancellationpolicy || '';

                setCancellationPolicyData({
                    title: result.title || 'Terms and Conditions',
                    cancellationPolicy: isHtmlEmpty(policyDetails) ? defaultPolicyContent : policyDetails
                });
            } else {
                setCancellationPolicyData({
                    title: 'Terms and Conditions',
                    cancellationPolicy: defaultPolicyContent
                });
            }
        } catch (error) {
            console.error("Error fetching Terms and Conditions:", error);
            setCancellationPolicyData({
                title: 'Terms and Conditions',
                cancellationPolicy: defaultPolicyContent
            });
        }
    };



    useEffect(() => {
        fetchCancellationPolicy();
    }, [gymId]);


    const fetchRazorpayGateway = async () => {
        try {
            const response = await getRazorpayGateway(gymId);
            if (!response || response === "false") {

                return;
            }

            const result = await response.json();
            console.log(result, "result");

            if (result?.error) {
                setRazorpayGatewayDocId("");
                setHasRazorpayWebhookSecret(false);
                return;
            }

            if (result) {
                console.log(result, "result");
                setOriginalKeyId(result?.razorkeyid || "");
                setOriginalSecret(result?.razorkeysecret || "");
                setRazorpayKeyId(result?.razorkeyid || "");
                setPaymentInfo(result?.orderdeatils);
                setRazorpaySecret(result?.razorkeysecret || "");
                setRazorpayGatewayDocId(result?._id || "");
                setHasRazorpayWebhookSecret(Boolean(result?.hasWebhookSecret));
                /* isverfied: 0 = API keys OK (pay yourself), 1 = failed, 2+ = not verified — unrelated to webhook */
                if (result?.isverfied === 0) {
                    setVerificationStatus('verified');
                } else if (result?.isverfied === 1) {
                    setVerificationStatus('failed');
                } else {
                    setVerificationStatus(null);
                }


            }
        } catch (error) {
            console.error("Error fetching Terms and Conditions:", error);

        }
    };



    useEffect(() => {
        fetchRazorpayGateway();
    }, [refresh]);


    const fetchPrivacyPolicy = async () => {
        try {
            const response = await getCustomisablePrivacy(gymId);
            if (!response || response === "false") {
                // Set default values if no response
                setPrivacyPolicyData({
                    title: 'Privacy Policy',
                    privacyPolicy: defaultPrivacyContent
                });
                return;
            }

            const result = await response.json();
            if (result) {
                const policyDetails = result.privacypolicy || result.privacyPolicy || '';

                setPrivacyPolicyData({
                    title: result.title || 'Privacy Policy',
                    privacyPolicy: isHtmlEmpty(policyDetails) ? defaultPrivacyContent : policyDetails
                });
            } else {
                setPrivacyPolicyData({
                    title: 'Privacy Policy',
                    privacyPolicy: defaultPrivacyContent
                });
            }
        } catch (error) {
            console.error("Error fetching Terms and Conditions:", error);
            setPrivacyPolicyData({
                title: 'Privacy Policy',
                privacyPolicy: defaultPrivacyContent
            });
        }
    };


    useEffect(() => {

        fetchCancellationPolicy();
    }, [gymId]);

    useEffect(() => {

        fetchPrivacyPolicy();
    }, [gymId]);


    useEffect(() => {
        if (!cancellationModal) {
            fetchCancellationPolicy();
        }
    }, [cancellationModal]);

    useEffect(() => {
        if (!privacyModal) {
            fetchPrivacyPolicy();
        }
    }, [privacyModal]);

    function getMainDomain(hostname) {
        const parts = hostname.split('.');
        if (parts.length >= 2) {
            return parts.slice(-2).join('.');
        }
        return hostname;
    }

    const mainDomain = getMainDomain(window.location.hostname);

    // const url = new URL("https://easymembr.com/classesbusiness");
    // const url = new URL("https://zencruz.com/classesbusiness")
    // const hostname = url.hostname;

    // const mainDomain = getMainDomain(hostname);
    console.log(mainDomain);
    const handleReload = () => {
        window.location.reload();
    }
    useEffect(() => {

        const handleImageLoad = () => {
            setImageLoaded(true);
        };

        const handleImageError = () => {
            setImageLoaded(false);
        };
        const imgElement = document.createElement("img");
        imgElement.onload = handleImageLoad;
        imgElement.onerror = handleImageError;
        imgElement.src = logourl;

        return () => {
            imgElement.onload = null;
            imgElement.onerror = null;
        };
    }, [logourl]);

    function encryptId(id) {
        return btoa(id);
    }
    useEffect(() => {
        if ((PaymentLink && PaymentLink.toggle) && PaymentLink.status == 2) {
            setTimeout(() => {
                checkingConfirmStatus();
            }, 5000);
        }
    }, [PaymentLink]);
    async function checkingConfirmStatus() {
        let gymid = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;
        try {
            let response = await reqConfirmPaymentStatus(gymid);
            if (!response) {
                return;
            }
            if (response === "false") {
                return;
            }
            const resObject = await response.json();
            console.log(resObject);
            setPaymentLink(resObject);
            if (resObject && resObject.status && (resObject.status === 1 || resObject.status === 0)) {
                if (resObject.status === 1) {
                    setError2("Successfully confirmed payment.");
                }
            }
        } catch (e) {
            console.log(e);
        }
    }
    function generateUniqueKey(length) {
        const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
        let uniqueKey = '';
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            uniqueKey += characters.charAt(randomIndex);
        }
        return uniqueKey;
    }

    function saveWaiverSettings(data) {
        setWaiverForm(data);
        DigitalWaverShow();
        const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo")) || {};

        const fullName =
            (userInfo.fname && userInfo.lname)
                ? `${userInfo.fname} ${userInfo.lname}`
                : userInfo.name || "User";

        const username1 = userInfo.email || "Guest";
        const gymid = userInfo.gymid || "";
        const ip = localStorage.getItem("ipaddress") || " ";
        const browserinfo = `${browserName}-${browserVersion}.0.0`;

        const Eventtype = username1;
        const flag = `Waiver settings updated successfully (${fullName})`;
        setAlerttxt(flag);

        logEvent(
            {
                Eventtype,
                username1,
                ip,
                flag,
                browserinfo,
                gymid,
                isclass: true
            },
            gymid
        );

    }


    useEffect(() => {
        if (localStorage.getItem("loggedUserInfo")) {
            fetchData();
            fetchGeolocation();
        } else {
            window.location.href = "/login"
        }
        async function fetchGeolocation() {
            const getlocation = await getLocation(
                JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
            );
            if (!getlocation) {
                return;
            }

            if (getlocation === "false") {
                return;
            }
            const getloc = await getlocation.json();
            console.log(getloc);
            if (!getloc.gymid) {
                let id = JSON.parse(localStorage.getItem("loggedUserInfo")) ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";
                const updates = {
                    latitude: 17.43496886763314,
                    longitude: 78.35971199722289,
                    address: "",
                    gymid: id,
                    radius: 100,
                };
                console.log(updates);
                const saverep = await updateLocation(id, updates);
                const recinf = await saverep.json();
                setGeolocation(recinf);
            } else {
                setGeolocation(getloc);
            }
        }
        async function fetchData() {
            if (localStorage.getItem("loggedUserInfo")) {
                const waiverRes = await getWaiverSettingsbyGymid(
                    JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
                );
                if (waiverRes === "false") {
                    setApiError(true)
                } else {
                    const waiver = await waiverRes.json();
                    console.log(waiver);
                    if (!waiver.gymid) {
                        const updates = {
                            gymid: JSON.parse(localStorage.getItem("loggedUserInfo")).gymid,
                            uniqueNumber: generateUniqueKey(6),
                            emergencycontact: 2,
                            bloodgroup: 2,
                            address: 2,
                            phone: 1,
                            email: 1,
                            title: `Digital Waiver Form`,
                            checkboxcontent: `By checking this box, I acknowledge that I have read, understood, and agree to the terms and conditions
  outlined in the waiver form. I accept full responsibility for my participation, or for the participation of the
  minor I am legally responsible for, in climbing activities at Crag Studio, and recognize the inherent risks
  involved.`,
                            agreement:
                                `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
  dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
  aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
  dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia
  deserunt mollit anim id est laborum`
                        }
                        let saverep = await updateWaiverSettings(updates, JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
                        const recinf = await saverep.json();
                        console.log(recinf);
                        setWaiverForm(recinf);
                    } else {
                        setWaiverForm(waiver);
                    }
                }
                const response = await getGBussinessInfo(
                    JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
                );
                if (!response) {
                    return;
                }
                if (response === "false") {
                    setApiError(true)
                } else {

                    const recinfo = await response.json();
                    console.log(recinfo);
                    if (!recinfo) {
                        return;
                    }

                    if (localStorage.getItem("business_save")) {
                        setSMessage(localStorage.getItem("business_save"));
                        setTimeout(() => {
                            setSMessage(null);
                            localStorage.removeItem("business_save");
                        }, 5000);
                    }
                    const updatedInfo = { ...recinfo };

                    if (!updatedInfo.prefix) {
                        updatedInfo.prefix = updatedInfo.businessName ? updatedInfo.businessName.replace(/\s+/g, '').substring(0, 4) : "GYMA";
                    }
                    if (!updatedInfo.shortcode) {
                        updatedInfo.shortcode = "GYMADN";
                    }
                    if (!updatedInfo.country) {
                        updatedInfo.country = "India";
                        updatedInfo.state = "Telangana";
                    }
                    if (updatedInfo.dayid.includes(1) && updatedInfo.sunday.length === 0) {
                        updatedInfo.sunday = [{ fromTime: "0", toTime: "23" }];
                    } if (updatedInfo.dayid.includes(2) && updatedInfo.monday.length === 0) {
                        updatedInfo.monday = [{ fromTime: "0", toTime: "23" }];
                    } if (updatedInfo.dayid.includes(3) && updatedInfo.tuesday.length === 0) {
                        updatedInfo.tuesday = [{ fromTime: "0", toTime: "23" }];
                    } if (updatedInfo.dayid.includes(4) && updatedInfo.wednesday.length === 0) {
                        updatedInfo.wednesday = [{ fromTime: "0", toTime: "23" }];
                    } if (updatedInfo.dayid.includes(5) && updatedInfo.thursday.length === 0) {
                        updatedInfo.thursday = [{ fromTime: "0", toTime: "23" }];
                    } if (updatedInfo.dayid.includes(6) && updatedInfo.friday.length === 0) {
                        updatedInfo.friday = [{ fromTime: "0", toTime: "23" }];
                    } if (updatedInfo.dayid.includes(7) && updatedInfo.saturday.length === 0) {
                        updatedInfo.saturday = [{ fromTime: "0", toTime: "23" }];
                    }
                    setInfo(updatedInfo);
                    setClassbookingurl(updatedInfo.classbookingurl)
                    setPaymentmode(updatedInfo?.classpaymentmode ? updatedInfo.classpaymentmode : "offline")
                    console.log(updatedInfo);
                }
            }
        }
    }, []);
    const [subDomainData, setSubDomainData] = useState([]);
    const reseverSubDomain = [
        "test",
        "app",
        "www",
        "beta",
        "testing"
    ]
    console.log(mainDomain, 'mainDomain');

    const [currentdomain, setCurrentdomain] = useState({})
    async function fetchsubDomains() {
        const gymid = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;
        // const url = new URL("https://easymembr.com/classesbusiness");
        // const url = new URL("https://zencruz.com/classesbusiness")
        // const hostname = url.hostname;

        // const Domain = getMainDomain(hostname);
        const Domain = getMainDomain(window.location.hostname);
        const subDomainInfo = await getAllSubDomain(Domain);
        if (!subDomainInfo || subDomainInfo === "false") return;

        const subDomainData = await subDomainInfo.json();
        console.log(subDomainData, '999999999999999999999');
        setSubDomainData(subDomainData);

        const matchedDomain = subDomainData?.length > 0 ? subDomainData.find((item) => item.gymid === gymid) : {};
        if (matchedDomain) {
            setSubdomain(matchedDomain.subdomain)
            setCurrentdomain(matchedDomain);
        } else {
            setCurrentdomain({});
        }
        setRefresh(false)
    }


    async function fetchPaymentLink() {
        const paymentLinkSetting = await getPaymentLinkSetting(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
        if (!paymentLinkSetting) {
            return;
        }
        if (paymentLinkSetting == "false") {
            return;
        }
        const paymentLinkSettings = await paymentLinkSetting.json();
        if (paymentLinkSettings.gymid) {
            console.log(paymentLinkSettings);
            setPaymentLink(paymentLinkSettings);
            if (paymentLinkSettings.status == 2) {
                checkingConfirmStatus();
            }
        }
    }

    useEffect(() => {
        fetchsubDomains();

    }, [refresh]);

    useEffect(() => {
        fetchPaymentLink();

    }, []);
    const [basicModal, setBasicModal] = useState(false);
    const toggleShow = () => setBasicModal(!basicModal);



    const [paymentMethods, setPaymentMethods] = useState(false);
    const paymentMethodsShow = () => setPaymentMethods(!paymentMethods);
    const [taxSettings, setTaxSettings] = useState(false);
    const taxSettingsShow = () => setTaxSettings(!taxSettings);

    const [userUrlSetting, setUserUrlSetting] = useState(false)
    const userUrlSettingsShow = () => setUserUrlSetting(!userUrlSetting);
    const [paymentSetting, setPaymentSetting] = useState(false)
    const paymentSettingShow = () => setPaymentSetting(!paymentSetting);

    const [locationSetting, setLocationSetting] = useState(false);
    const locationFenchingShow = () => setLocationSetting(!locationSetting);

    const [bussinessHours, setBussinessHours] = useState(false);
    const bussinessHoursShow = () => setBussinessHours(!bussinessHours);

    const [DigitalWaver, setDigitalWaver] = useState(false);
    const DigitalWaverShow = () => setDigitalWaver(!DigitalWaver);

    const [QRDigitalWaver, setQRDigitalWaver] = useState(false);
    const QRDigitalWaverShow = () => setQRDigitalWaver(!QRDigitalWaver);
    const userQRCodeHandler = () => setUserQRCode(!userQRCode);
    const [QRDigitalWaverconfirmation, setQRDigitalWaverconfirmation] = useState(false);
    const QRDigitalWaverconfirmationShow = () => setQRDigitalWaverconfirmation(!QRDigitalWaverconfirmation);
    const [copyLink, setcopyLink] = useState(false);

    let uniqueId = WaiverForm.uniqueNumber;
    const encryptedId = encryptId(uniqueId);
    const pathAndQuery = `/waiver?id=${encryptedId}`;
    const baseUrl = window.location.origin;
    const fullUrl = baseUrl + pathAndQuery;
    const link = fullUrl;
    const handleCloseBooking = () => {
        const gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : -1
        const matchedDomain = subDomainData?.length > 0 ? subDomainData.find((item) => item.gymid === gymid) : {};
        if (matchedDomain) {
            setSubdomain(matchedDomain.subdomain)
            setCurrentdomain(matchedDomain);
        } else {
            setCurrentdomain({});
        }

        // setPaymentmode("offline")
        userUrlSettingsShow()
        setRefresh(true)
    }
    const reGenerateLink = async () => {
        const updates = {
            gymid: localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "",
            uniqueNumber: generateUniqueKey(6),
        };
        let saverep = await updateWaiverSettings(updates, localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "");
        if (saverep === "false") {
            setApiError(true)
        } else {
            const recinfo = await saverep.json();
            console.log(recinfo);
            setWaiverForm(recinfo);
        }
        QRDigitalWaverconfirmationShow();
    };
    const handleCopyLink = () => {
        copy(link);
        setcopyLink(true);
    };
    // const handlePreview = () => {
    //   window.open(link, '_self');
    // };
    const modalBodyRef = useRef(null);
    // <link rel="icon" href="../../build/favicon.ico" />
    // <link rel="icon" href=${faviconUrl}/>
    const handlePrintPDF = (url) => {
        const contentToPrint = `
    <html>
      <head>
      <title>Gym Management</title>
  <link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
  <link rel="icon" href="/favicon.ico" />
          </head>
      <body style="background-color:#d7e1ee;">
        <center>
        <div style="
        min-width: 50%;
        background-color: #fff;
        padding: 0px 0px 160px 0px;
        border-radius: 7px;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.075);
        ">
        <div className='d-flex align-items-center Waiver-logo'>
        <div style="display: flex;align-items: center;justify-content: center;">
          <img src=${imageLoaded ? logourl : logo} style="width:140px" />
          <div style="display: flex;align-items: flex-start;flex-direction: column;margin-top: 0.5rem;border-left: 2px solid #e0e0e0;padding-left: 0.5rem;">
            <h4 style="color: #193b8b; margin:0px; !important; font-family: &quot;Inter&quot;, sans-serif;">${info && info.businessName ? info.businessName : "GYM Admin Online"}</h4>
            <div className='d-flex'>
              <p style="margin:0px; !important;margin-top: 10px; font-family: &quot;Inter&quot;, sans-serif;">
              ${(info.address || info.city) ? ((info.address ? info.address : '') +
                ((info.address && info.city) ? ', ' : '') +
                (info.city ? (info.city) : '')
            ) : "Suadaraiah Vignana Kendram, Gachibowli, Hyderabad"}
              </p>
              </div>
              </div>
              </div>
              </div>
              <div style="border-bottom: 2px solid #ddd;margin: 15px 0px;width: 90%;"></div>
              <div>
              <h1 style="padding-top: 20px;font-family: &quot;Inter&quot;, sans-serif;">Class Booking QR Code</h1><br/>
              <div>
              ${ReactDOMServer.renderToString(<QRCodeSVG style={{ width: '300px', height: '300px' }} value={url} />)}
              </div>
              </div>
              </div>
        </center>
      </body>
    </html>
  `;


        // Create a hidden iframe
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        document.body.appendChild(iframe);

        // Write content to the iframe
        const iframeDoc = iframe.contentWindow.document;
        iframeDoc.open();
        iframeDoc.write(contentToPrint);
        iframeDoc.close();

        // Print the content
        setTimeout(() => {
            iframe.contentWindow.print();
            document.body.removeChild(iframe);
        }, 200);
    };

    const truncateContent = (content, maxLength) => {
        if (content && (content.length > maxLength)) {
            return content.substring(0, maxLength) + '...';
        } else {
            return content;
        }
    };
    const stripHtmlTags = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    };

    console.log("inside zencruz");

    const [classbookingurl, setClassbookingurl] = useState("")
    const [subdomain, setSubdomain] = useState("")

    const [isVerifying, setIsVerifying] = useState(false);
    const [subdomainError, setSubdomainError] = useState("");
    const [paymentmode, setPaymentmode] = useState("offline")
    console.log(subdomain, 'subdomain');

    const handleUserURL = (e) => {
        setClassbookingurl(e.target.value)
    }
    // const handleSubDomain = (e) => {
    //     setSubdomain(e.target.value)
    // }
    const handleSubDomain = async (e) => {
        const value = e.target.value.trim().toLowerCase(); // Normalize input
        setSubdomain(value);
        setIsVerifying(true);
        setSubdomainError("");

        // Simulate small delay for UX or real-time checking
        setTimeout(() => {
            // Check in reserved list
            const isReserved = reseverSubDomain.includes(value);
            // Check in existing data
            const gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : -1;
            const isTaken = subDomainData.some(d => d.subdomain?.toLowerCase() === value && d.gymid !== gymid);

            if (isReserved || isTaken) {
                setSubdomainError("Subdomain is not available");
            } else {
                setSubdomainError("");
            }
            setIsVerifying(false);
        }, 500);
    };

    const handlePaymentChange = (e) => {
        setPaymentmode(e.target.value);
    };

    const handlecopyDomainuserUrl = () => {

        copy(`https://${currentdomain.subdomain}.${mainDomain}/booking`)
        setcopyLink(true);
    }

    const handlecopyuserUrl = () => {
        const path = window.location.origin
        console.log(path, 'pathpathpathpathpath');

        copy(`${path}/booking?id=${classbookingurl}`)
        setcopyLink(true);
    }
    const handlecopyUrl = (url) => {
        copy(url)
        setcopyLink(true);
    }
    const onSaveClassBookingUrl = async () => {
        if (subdomainError || isVerifying) {
            alert("Please fix the subdomain issue before saving.");
            return;
        }


        const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo")) || {};

        const fullName =
            (userInfo.fname && userInfo.lname)
                ? `${userInfo.fname} ${userInfo.lname}`
                : userInfo.name || "User";

        const username1 = userInfo.username || userInfo.email || "Guest";
        const gymid = userInfo.gymid || "";
        const ip = localStorage.getItem("ipaddress") || "Unknown IP";
        const browserinfo = `${browserName}-${browserVersion}.0.0`;
        const Eventtype = "subdomain Settings Updated";
        const flag = `Subdomain settings have been updated by ${fullName}`;

        setAlerttxt(flag);


        const update = {
            classbookingurl: classbookingurl,
            classpaymentmode: paymentmode
        };

        if (subdomain !== "" || subdomain !== currentdomain.subdomain) {
            const subdmoaininfo = {
                subdomain: subdomain,
                gymid: info._id,
                status: 1,
                domain: mainDomain,
            };
            console.log(subdmoaininfo, 'subdmoaininfo');


            const res = await createSubDomain(info._id, subdmoaininfo);

            logEvent({
                Eventtype: "Subdomain Created/Updated",
                username1,
                ip,
                flag: `Subdomain (${subdomain}) updated successfully(${fullName})`,
                browserinfo,
                gymid,
                isclass: true,
            }, gymid);
            await trackButtonClick("ClassBusinessInfo", "Update_Class_booking_URL", "staff", {});
        }
        if (paymentmode === "online" && verificationStatus === 'verified') {
            const isWebhookOnlyUpdate =
                razorpayWebhookSecretInput.trim().length > 0 &&
                razorpayKeyId === originalKeyId &&
                razorpaySecret === originalSecret &&
                paymentmode === originalPaymentMode;

            const update = {
                razorkeyid: razorpayKeyId,
                razorkeysecret: razorpaySecret,
                gymid: info._id,
                razorpay_order_id: paymentInfo?.razorpay_order_id,
                razorpay_payment_id: paymentInfo?.razorpay_payment_id,
                razorpay_signature: paymentInfo?.razorpay_signature,
            };
            if (!isWebhookOnlyUpdate) {
                update.isverfied = 0;
            }
            if (razorpayGatewayDocId) {
                update._id = razorpayGatewayDocId;
            }
            if (razorpayWebhookSecretInput.trim()) {
                update.webhooksecret = razorpayWebhookSecretInput.trim();
            }
            console.log(update);
            console.log(paymentInfo);


            const razorgatewayres = await createRazorpayGateway(info._id, update)

            console.log("razorgatewayres", razorgatewayres);

            logEvent({
                Eventtype: "Razorpay Online Setup",
                username1,
                ip,
                flag: `Razorpay (Online) configured successfully(${fullName})`,
                browserinfo,
                gymid,
                isclass: true,
            }, gymid);


        }
        if (paymentmode === "offline") {
            const razorClearUpdate = {
                razorkeyid: "",
                razorkeysecret: "",
                gymid: info._id,
                isverfied: 2,
                webhooksecret: "",
            };
            if (razorpayGatewayDocId) {
                razorClearUpdate._id = razorpayGatewayDocId;
            }
            await createRazorpayGateway(info._id, razorClearUpdate);

            logEvent({
                Eventtype: "Razorpay Offline Setup",
                username1,
                ip,
                flag: `Razorpay (Offline) configured successfully  (${fullName})`,
                browserinfo,
                gymid,
                isclass: true,
            }, gymid);


            // // Optional: Clear local state too
            // setRazorpayKeyId("");
            // setRazorpaySecret("");
            // setVerificationStatus(null);
            // setOriginalKeyId("");
            // setOriginalSecret("");
        }

        let saverep = await saveGBussinessInfo(update, info._id);
        await saverep.json();

        logEvent({
            Eventtype: "Class Booking URL/Payment Mode Saved",
            username1,
            ip,
            flag: `Class booking settings updated successfully(${fullName})`,
            browserinfo,
            gymid,
            isclass: true,
        }, gymid);


        setRefresh(true);
        setOriginalKeyId(razorpayKeyId);
        setOriginalSecret(razorpaySecret);
        setRazorpayWebhookSecretInput("");

        userUrlSettingsShow();
    };


    useEffect(() => {
        if (isMobile) {
            setModeOpen(false)
            setMode("over")
        }
    }, [])

    const sideNav = () => {
        setModeOpen(!modeOpen);
        if (isMobile) {
            setMode("over")
        } else {
            setMode("side")
        }
    }
    console.log(subdomain, 'subdomain');
    let col = 4;
    if ((plansInfo !== null && !plansInfo?.feature?.digitalwaiver)) {
        col = 6;
    }

    const handlePayment = async (e, res) => {
        console.log(res, 'resres');

        if (res == "Invalid keys") {
            setAlerttxt("Please Provide Valid Keys");
            setErrors(true)
            return;
        }
        if (!razorpayKeyId || !razorpaySecret) {
            alert("Please enter both Razorpay Key ID and Secret");
            return;
        }
        console.log(res, 'res');

        if (!razorpayKeyId.startsWith('rzp_test_') && !razorpayKeyId.startsWith('rzp_live_')) {
            setAlerttxt("Failed, Invalid Razorpay Key ID format. Must start with 'rzp_test_' or 'rzp_live_'");
            setErrors(true)
            return;
        }

        if (razorpayKeyId.length < 20 || razorpaySecret.length < 20) {
            setAlerttxt("Failed, Razorpay credentials appear to be incomplete. Please check your keys.");
            setErrors(true)
            return;
        }

        try {
            setLoader(true);
            setErrors(false)
            setAlerttxt("");

            if (res == "success") {
                setAlerttxt("Razorpay keys verified successfully! Demo payment of ₹100 completed.");
                setPaymentComplete(true);
                // setPaymentInfo(result.data);
                setVerificationStatus('verified');
                setOriginalKeyId(razorpayKeyId);
                setOriginalSecret(razorpaySecret);

            } else {
                setAlerttxt("Please Provide Valid Keys");
                setErrors(true)

            }

        } catch (error) {
            console.error(error);

            setAlerttxt("Payment failed!");
            console.log("Transaction saved successfully");
            setVerificationStatus('failed');
            setPaymentComplete(false);
            setPaymentInfo(null);

        }
    };





    const hasKeysChanged = () => {
        return razorpayKeyId !== originalKeyId || razorpaySecret !== originalSecret;
    };




    console.log("verificationStatus", verificationStatus);

    const totalAmount = 100;

    const userdetails = {
        name: `${info?.firstName}` || "" + `${info?.lastName}` || "",
        email: info?.email || '',
        contact: info.number ? info.number : ""
    }


    const hasChangesToSave = () => {
        return (
            razorpayKeyId !== originalKeyId ||
            razorpaySecret !== originalSecret ||
            paymentmode !== originalPaymentMode ||
            razorpayWebhookSecretInput.trim().length > 0
        );
    };


    const fetchWaiverSettings = async () => {
        try {
            const response = await getClassBookingWaiverSettings(gymId);
            if (!response || response === "false") return;

            const result = await response.json();
            console.log("result", result);

        } catch (error) {
            console.error("Error fetching Terms and Conditions:", error);
        }
    };

    useEffect(() => {

        fetchWaiverSettings();
    }, [gymId]);


    const fetchWaiverStatusForCard = async () => {
        try {
            const gymId = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;
            if (!gymId) return;

            const response = await getClassBookingWaiverSettings(gymId);
            if (!response || response === "false") {
                return;
            }

            const result = await response.json();
            setDigitalWaiverStatus(result.iswaiver);
        } catch (error) {
            console.error("Error fetching waiver status for card:", error);
        }
    };

    useEffect(() => {
        if (plansInfo?.feature?.digitalwaiver) {
            fetchWaiverStatusForCard();
        }
    }, [plansInfo]);


    const showAlert = (flag) => {
        console.log("Error2flag", flag);
        setAlerttxt(flag)
    }

    return (
        <>
            <SideNavClass activeTab={"classesbusiness"} modeOpen={modeOpen} setModeOpen={setModeOpen} mode={mode} setMode={setMode} >
                {apiError ? <PageError handleReload={handleReload} /> :
                    <>
                        {isMobile &&
                            <header class="gym-container gym-hide-large gym-red  gym-padding d-flex align-items-center p-3">
                                <div onClick={() => sideNav()} className='cursor-pointer'>
                                    <MDBIcon fas icon='bars' size='lg' />
                                </div>
                                <h5 class="ms-3 mb-0 d-inline">EasyMembr</h5>
                            </header>
                        }
                        <div
                            className="gym-main mt-0 px-2"
                        >
                            <div className="gym-container p-0" id="showcase">
                                {smessage && (
                                    <div>
                                        <Toast message={smessage} />
                                    </div>
                                )}
                            </div>

                            <div>
                                <div className="business_Info_page" id="contact" style={{ maxHeight: "calc(100vh - 100px)", overflowY: "auto", overflowX: "hidden" }}>
                                    <MDBRow>
                                        <MDBCol sm="12" md={col} lg={col} className='mt-mob-4'>

                                            {roleAccess?.businessdetails !== 0 && <MDBCard>
                                                <MDBCardBody>
                                                    <MDBCardTitle>
                                                        <label>Business Details </label>
                                                        <div>
                                                            {roleAccess?.businessdetails !== 2 && <MDBIcon fas icon="edit" onClick={() => toggleShow()} />}
                                                        </div>
                                                    </MDBCardTitle>
                                                    <MDBCardText>
                                                        <MDBRow>

                                                            <MDBCol>
                                                                <div className="payment-span chip">
                                                                    <label>Business Name:</label> <label className="fw-600">{info.businessName}</label>
                                                                </div>

                                                                <div className="payment-span chip">
                                                                    <label>Owner First Name:</label> <label className="fw-600">{info.firstName}</label>
                                                                </div>

                                                                <div className="payment-span chip">
                                                                    <label>Owner Last Name:</label> <label className="fw-600">{info.lastName}</label>
                                                                </div>

                                                                <div className="payment-span chip">
                                                                    <label>Email:</label> <label className="fw-600">{info.businessEmail}</label>
                                                                </div>

                                                                <div className="payment-span chip">
                                                                    <label>Contact No:</label> <label className="fw-600">{info.contactNumber}</label>
                                                                </div>

                                                                <div className="payment-span chip">
                                                                    <label>City:</label> <label className="fw-600">{info.city}</label>
                                                                </div>
                                                                <div className="payment-span chip">
                                                                    <label>State:</label> <label className="fw-600">{info.state}</label>
                                                                </div>

                                                                <div className="payment-span chip">
                                                                    <label>Country:</label> <label className="fw-600">{info.country}</label>
                                                                </div>
                                                                <div className="payment-span chip">
                                                                    <label>Timezone:</label> <label className="fw-600">{info.timezone && info.timezone.value}</label>
                                                                </div>

                                                                <div className="payment-span chip">
                                                                    <label>Transaction Id Prefix:</label> <label className="fw-600">{info.prefix}</label>
                                                                </div>

                                                                <div className="payment-span chip">
                                                                    <label>SMS ShortCode:</label> <label className="fw-600">{info.shortcode}</label>
                                                                </div>

                                                                <div className="payment-span chip">
                                                                    <label>Preferred Date Format:</label> <label className="fw-600 lower">{info.dateFormat || "YYYY/MM/DD"}</label>
                                                                </div>
                                                                <div className="payment-span chip">
                                                                    <label>Member Capacity:</label> <label className="fw-600">{info.memberCapacity}</label>
                                                                </div>

                                                                <div className="payment-span chip">
                                                                    <label>Business Address:</label> <label className="fw-600">{info.address}</label>
                                                                </div>
                                                                <div className="payment-span chip">
                                                                    <label>GST Number:</label> <label className="fw-600">{info.gstnumber && info.gstnumber !== "" ? info.gstnumber : "--"}</label>
                                                                </div>
                                                                <div className="payment-span chip">
                                                                    <label>Member Check-In Duration:</label> <label className="fw-600">{info.checkoutduration ? info.checkoutduration : 1.5} hours</label>
                                                                </div>

                                                                <div className="mt-3">
                                                                    <label className="m-0 fw-600">Bussiness Logo:</label>
                                                                    <div className="py-2">
                                                                        <img src={imageLoaded ? logourl : logo} alt="Selected" style={{ maxWidth: '100%', maxHeight: '80px' }} />
                                                                    </div>
                                                                </div>
                                                            </MDBCol>

                                                        </MDBRow>

                                                    </MDBCardText>
                                                </MDBCardBody>
                                            </MDBCard>}

                                            {roleAccess?.privacypolicy != 0 && <MDBCard className='mt-3'>
                                                <MDBCardBody>
                                                    <MDBCardTitle>
                                                        <label>Privacy Policy:</label>
                                                        {roleAccess?.privacypolicy !== 2 && <div onClick={PrivacyModalShow}>
                                                            <MDBIcon fas icon="edit" />
                                                        </div>}
                                                    </MDBCardTitle>
                                                    <MDBCardText>
                                                        <div className="mt-3">
                                                            <p className='mt-2 mb-1 fw-bold'>Title</p>
                                                            <label className="mt-0">{privacyPolicyData.title}</label>
                                                        </div>
                                                        <div className="mt-3">
                                                            <p className='mt-2 mb-1 fw-bold'>Content</p>
                                                            <label
                                                                className="mt-0"
                                                                title={stripHtmlTags(privacyPolicyData.privacyPolicy)}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: truncateContent(privacyPolicyData.privacyPolicy, 300)
                                                                }}
                                                            />
                                                        </div>
                                                    </MDBCardText>
                                                </MDBCardBody>
                                            </MDBCard>}

                                        </MDBCol>

                                        <MDBCol sm="12" md={col} lg={col} className='mt-mob-4'>

                                            {roleAccess?.userclassbookingurl != 0 && <MDBCard>
                                                <MDBCardBody>
                                                    <MDBCardTitle>
                                                        <label>User Class Booking URL</label>
                                                        {roleAccess?.userclassbookingurl !== 2 && <div onClick={userUrlSettingsShow}>
                                                            <MDBIcon fas icon="edit" />
                                                        </div>}
                                                    </MDBCardTitle>
                                                    <MDBCardText>
                                                        {currentdomain.subdomain && <div>
                                                            <label><b>SubDomain : </b></label>
                                                            <span className='mx-2 '>{currentdomain.subdomain}</span>
                                                        </div>}
                                                        {currentdomain.subdomain && <div className="payments  mt-3">
                                                            <label><b>Booking URL : </b> </label>
                                                            <div className='d-flex align-items-center flex-wrap'>
                                                                <span>1.
                                                                </span>
                                                                <a className="pe-3 ps-0 domain-link " href={`https://${currentdomain.subdomain}.${mainDomain}/booking`}> {`https://${currentdomain.subdomain}.${mainDomain}/booking`}</a>
                                                                <div className='d-flex align-items-center' style={{ fontSize: '12px' }}>
                                                                    <span className='text-blue fw-300 fs-6 cursor-pointer' onClick={handlecopyDomainuserUrl}><i class="fa-regular fa-copy"></i></span>
                                                                    <label className='ms-2'>
                                                                        {currentdomain.status == 3 ?
                                                                            <label
                                                                                className="clr-green ms-1"
                                                                            >
                                                                                <MDBIcon fas icon="check" />INSYNC
                                                                            </label>
                                                                            : ""}
                                                                        {currentdomain.status == 2 ? <label className="clr-orange  ms-1">
                                                                            <MDBIcon far icon="clock" /> PENDING
                                                                        </label> : ""}
                                                                        {currentdomain.status == 0 ? <label className="clr-red  ms-1">
                                                                            <MDBIcon fas icon="times" /> FAILED
                                                                        </label> : ""}
                                                                        {currentdomain.status == 1 ?
                                                                            <label className="text-info">
                                                                                <MDBIcon fas icon="sync-alt" />VERIFYING
                                                                            </label> : ""}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className='d-flex align-items-center flex-wrap'>
                                                                <span>2.
                                                                </span>
                                                                <a className="pe-3 ps-0 domain-link " href={`https://${currentdomain.subdomain}.${mainDomain}/sessions/`}> {`https://${currentdomain.subdomain}.${mainDomain}/sessions/`}</a>
                                                                <div className='d-flex align-items-center' style={{ fontSize: '12px' }}>
                                                                    <span className='text-blue fw-300 fs-6 cursor-pointer' onClick={() => handlecopyUrl(`https://${currentdomain.subdomain}.${mainDomain}/sessions/`)}><i class="fa-regular fa-copy"></i></span>
                                                                </div>
                                                            </div>
                                                        </div>}

                                                        <div>
                                                            <label><b>Payment Mode : </b></label>
                                                            <span className='mx-2 '>{paymentmode}</span>
                                                        </div>
                                                        {/* {paymentmode === "online" && razorpayWebhookUrl && (
                                                            <div className="mt-3 p-2 rounded border bg-light">
                                                                <p className="fw-bold small mb-1">Razorpay webhook URL <span className="fw-normal text-muted">(optional)</span></p>
                                                                <p className="small text-muted mb-2">
                                                                    Add in Razorpay → Webhooks for instant updates; otherwise your existing scheduled job still updates payments. Paste the webhook <strong>signing secret</strong> in edit — this is separate from API key &quot;Verified&quot; (Pay yourself only).
                                                                </p>
                                                                <div className="d-flex align-items-start flex-wrap gap-2">
                                                                    <code className="small text-break flex-grow-1" style={{ fontSize: "12px" }}>{razorpayWebhookUrl}</code>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-link btn-sm p-0 text-primary"
                                                                        onClick={() => { copy(razorpayWebhookUrl); setcopyLink(true); }}
                                                                        title="Copy webhook URL"
                                                                    >
                                                                        <i className="fa-regular fa-copy" />
                                                                    </button>
                                                                </div>
                                                                <div className="small mt-2 mb-0">
                                                                    <span className="fw-semibold">Webhook secret saved: </span>
                                                                    {hasRazorpayWebhookSecret ? (
                                                                        <span className="text-success"><i className="fas fa-check-circle me-1" />Yes</span>
                                                                    ) : (
                                                                        <span className="text-muted">No — optional</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )} */}
                                                        {paymentmode === "online" && (
                                                            <div className="mt-3">
                                                                {verificationStatus && (
                                                                    <div>
                                                                        <div className='d-block  d-md-flex align-items-center'>
                                                                            <h6 className=" mb-0 me-3">Razorpay Keys</h6>
                                                                            <div className="">
                                                                                {' '}
                                                                                <i
                                                                                    className={`fas me-1 ${verificationStatus === 'verified'
                                                                                        ? 'fa-check-circle text-success'
                                                                                        : verificationStatus === 'failed'
                                                                                            ? 'fa-times-circle text-danger'
                                                                                            : 'fa-info-circle text-secondary'
                                                                                        }`}
                                                                                ></i>
                                                                                {verificationStatus === 'verified'
                                                                                    ? 'Verified'
                                                                                    : verificationStatus === 'failed'
                                                                                        ? 'Failed'
                                                                                        : 'Not Verified'}
                                                                            </div>
                                                                        </div>

                                                                        <label>
                                                                            <strong>Key ID:</strong> {razorpayKeyId && razorpayKeyId.length > 8 ? `${razorpayKeyId.substring(0, 8)}...` : (razorpayKeyId || "—")}<br />
                                                                            <strong>Secret:</strong> {razorpaySecret && razorpaySecret.length > 8 ? `${razorpaySecret.substring(0, 8)}...` : (razorpaySecret ? "••••••••" : "—")}
                                                                        </label>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}

                                                    </MDBCardText>

                                                </MDBCardBody>
                                                <div>
                                                    <div className="routing-border">
                                                    </div>

                                                    <div className="d-flex align-items-center justify-content-center mb-3">
                                                        {/* <MDBBtn className="ms-2" onClick={handlecopyuserUrl}>
                                                            Copy Link
                                                        </MDBBtn> */}
                                                        <MDBBtn className="ms-2" onClick={userQRCodeHandler}><MDBIcon fas icon="qrcode" /> Show QR Code</MDBBtn>

                                                    </div>
                                                </div>
                                            </MDBCard>}

                                            {roleAccess?.termsandconditions != 0 && <MDBCard className='my-3'>
                                                <MDBCardBody>
                                                    <MDBCardTitle>
                                                        <label>Terms and Conditions</label>
                                                        {roleAccess?.termsandconditions !== 2 && <div onClick={canCellationModalShow}>
                                                            <MDBIcon fas icon="edit" />
                                                        </div>}
                                                    </MDBCardTitle>
                                                    <MDBCardText>
                                                        <div className="mt-3">
                                                            <p className='mt-2 mb-1 fw-bold'>Title</p>
                                                            <label className="mt-0">{cancellationPolicyData.title}</label>
                                                        </div>
                                                        <div className="mt-3">
                                                            <p className='mt-2 mb-1 fw-bold'>Content</p>
                                                            <label
                                                                className="mt-0"
                                                                title={stripHtmlTags(cancellationPolicyData.cancellationPolicy)}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: truncateContent(cancellationPolicyData.cancellationPolicy, 300)
                                                                }}
                                                            />
                                                        </div>
                                                    </MDBCardText>
                                                </MDBCardBody>
                                            </MDBCard>}


                                            {roleAccess?.announcements != 0 && <MDBCard>
                                                <MDBCardBody>
                                                    <Announcements roleAccess={roleAccess} />

                                                </MDBCardBody>
                                            </MDBCard>}
                                        </MDBCol>

                                        {(plansInfo !== null && plansInfo.feature.digitalwaiver) && roleAccess?.digitalwaiver != 0 ? <>
                                            <MDBCol sm="12" md="4" lg="4" className='mt-mob-4'>
                                                <MDBCard className="mb-4">
                                                    <MDBCardBody>
                                                        <MDBCardTitle>
                                                            <label> Digital Waiver </label>
                                                            {roleAccess?.digitalwaiver !== 2 && <div onClick={() => DigitalWaverShow()}>
                                                                <MDBIcon fas icon="edit" />
                                                            </div>}
                                                        </MDBCardTitle>
                                                        <MDBCardText>

                                                            <div className="mt-3">
                                                                <p className='mt-2 mb-1 fw-bold'>Title</p>
                                                                <label className="mt-0">{WaiverForm.title}</label>
                                                            </div>
                                                            <div className="mt-3">
                                                                <h6 className='mt-2 fw-bold'>Content checkbox text</h6>
                                                                <div title={stripHtmlTags(WaiverForm.checkboxcontent)} className="ps-0">{truncateContent(WaiverForm.checkboxcontent, 200)}</div>

                                                                <h6 className='mt-2 fw-bold'>Agreement text</h6>
                                                                <div className="ps-0" title={stripHtmlTags(WaiverForm.agreement)} dangerouslySetInnerHTML={{ __html: truncateContent(WaiverForm.agreement, 300) }} />

                                                                <h6 className='mt-3'>Optional fields</h6>
                                                                <div className='d-flex flex-wrap'>
                                                                    <MDBChip>
                                                                        <span className='me-1'>Email: </span>
                                                                        <span className='fw-600 '>
                                                                            {WaiverForm.email === 1 ? 'Mandatory' :
                                                                                WaiverForm.email === 2 ? 'Optional' :
                                                                                    WaiverForm.email === 3 ? 'Exclude' : ''}
                                                                        </span>
                                                                    </MDBChip>
                                                                    <MDBChip>
                                                                        <span className='me-1'>Phone: </span>
                                                                        <span className='fw-600 '>
                                                                            {WaiverForm.phone === 1 ? 'Mandatory' :
                                                                                WaiverForm.phone === 2 ? 'Optional' :
                                                                                    WaiverForm.phone === 3 ? 'Exclude' : ''}
                                                                        </span>
                                                                    </MDBChip>
                                                                    <MDBChip>
                                                                        <span className='me-1'>Blood group: </span>
                                                                        <span className='fw-600 '>
                                                                            {WaiverForm.bloodgroup === 1 ? 'Mandatory' :
                                                                                WaiverForm.bloodgroup === 2 ? 'Optional' :
                                                                                    WaiverForm.bloodgroup === 3 ? 'Exclude' : ''}
                                                                        </span>
                                                                    </MDBChip>
                                                                    <MDBChip>
                                                                        <span className='me-1'>Address: </span>
                                                                        <span className='fw-600 '>
                                                                            {WaiverForm.address === 1 ? 'Mandatory' :
                                                                                WaiverForm.address === 2 ? 'Optional' :
                                                                                    WaiverForm.address === 3 ? 'Exclude' : ''}
                                                                        </span>
                                                                    </MDBChip>
                                                                    <MDBChip>
                                                                        <span className='me-1'>Emergency contact: </span>
                                                                        <span className='fw-600 '>
                                                                            {WaiverForm.emergencycontact === 1 ? 'Mandatory' :
                                                                                WaiverForm.emergencycontact === 2 ? 'Optional' :
                                                                                    WaiverForm.emergencycontact === 3 ? 'Exclude' : ''}
                                                                        </span>
                                                                    </MDBChip>
                                                                </div>
                                                                <div className="routing-border">
                                                                </div>

                                                                <div className="d-flex align-items-center justify-content-center">
                                                                    <MDBBtn className="ms-2" onClick={QRDigitalWaverShow}><MDBIcon fas icon="qrcode" /> Show QR Code</MDBBtn>

                                                                </div>
                                                            </div>
                                                        </MDBCardText>
                                                    </MDBCardBody>
                                                </MDBCard>
                                                {(plansInfo !== null && plansInfo.feature.digitalwaiver) && roleAccess?.classbusinesssettings != 0 ? <>
                                                    <MDBCard className="mb-4">
                                                        <MDBCardBody>
                                                            <MDBCardTitle className='mb-3'>
                                                                <label > Class Business Settings </label>
                                                                {roleAccess?.classbusinesssettings !== 2 && <div onClick={() => classSettingsShow()}>
                                                                    <MDBIcon fas icon="edit" />
                                                                </div>}
                                                            </MDBCardTitle>
                                                            <MDBCardText>
                                                                <p className='fw-bold mb-1'>Digital Waiver Settings</p>
                                                                <div>
                                                                    <label> Wavier Form :  </label>
                                                                    {digitalWaiverStatus ?
                                                                        <>
                                                                            {"  "}
                                                                            <i className="fas fa-check-circle me-2 text-success"></i>   Mandatory
                                                                        </>
                                                                        : ' Optional'}
                                                                </div>
                                                            </MDBCardText>
                                                        </MDBCardBody>
                                                    </MDBCard>
                                                </> : ""}
                                            </MDBCol>
                                        </> : ""}

                                    </MDBRow>
                                </div >
                            </div >
                        </div>
                    </>

                }

                <MDBModal open={basicModal} setOpen={setBasicModal} show={basicModal} setShow={setBasicModal} tabIndex='-1'>
                    <MDBModalDialog>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Business Details</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={toggleShow}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>

                                <BusinessPage toggleShow={toggleShow} Gid={info._id} from="class" onbacktoStaff={onbacktoStaff} />

                            </MDBModalBody>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>


                <MDBModal show={paymentMethods} setShow={setPaymentMethods} open={paymentMethods} setOpen={setPaymentMethods} tabIndex='-1'>
                    <MDBModalDialog>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Payment Methods</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={paymentMethodsShow}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>
                                {paymentMethods && <PaymentMethods toggleShow={setPaymentMethods} paymentMethods={paymentMethods} from="class" />}

                            </MDBModalBody>

                            <MDBModalFooter className="d-none">
                                <MDBBtn color='secondary' onClick={paymentMethodsShow}>
                                    Close
                                </MDBBtn>
                                <MDBBtn>Save</MDBBtn>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>

                <MDBModal show={userUrlSetting} setShow={setUserUrlSetting} open={userUrlSetting} setOpen={setUserUrlSetting} tabIndex='-1'>
                    <MDBModalDialog>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>User Class booking URL Settings</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={handleCloseBooking}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody className='py-2'>
                                <div className='position-relative'>
                                    {(plansInfo !== null && plansInfo.feature.subdomain) &&
                                        <div className=''>
                                            <label className=' mb-1'>Sub Domain </label>
                                            <MDBInputGroup className='mb-3 urlinput' textBefore='https://' textAfter={`.${mainDomain}/booking`}>
                                                <input className='form-control url_inputfild' type='text' placeholder='Book your subdomain' onChange={handleSubDomain} value={subdomain} />
                                            </MDBInputGroup>
                                        </div>}
                                    {isVerifying ? (
                                        <p className="text-info m-0 position-absolute status-text">Verifying...</p>
                                    ) : (subdomainError ? (
                                        <p className="text-danger m-0 position-absolute status-text">{subdomainError}</p>
                                    ) : ((subdomain !== "" && subdomain !== undefined) ? (
                                        <p className="text-info m-0 position-absolute status-text">Available</p>) : <p></p>
                                    ))}
                                    <div className=''>
                                        <label className=' mb-1'>Booking URL Prefix</label>
                                        <MDBInputGroup className='mb-3 urlinput' textBefore={`${window.location.origin}/booking?id=`}>
                                            <input className='form-control url_inputfild' type='text' placeholder='Book your subdomain' onChange={handleUserURL} value={classbookingurl} />
                                        </MDBInputGroup>

                                    </div>

                                </div>
                                <div className=" my-3">
                                    <label className=' mb-1'>Payment Mode</label>
                                    <div className="d-flex">
                                        <MDBRadio
                                            name="paymentmode"
                                            id="offlineRadio"
                                            value="offline"
                                            label="Offline"
                                            inline
                                            checked={paymentmode === "offline"}
                                            onChange={handlePaymentChange}
                                        />
                                        <MDBRadio
                                            name="paymentmode"
                                            id="onlineRadio"
                                            value="online"
                                            label="Online"
                                            inline
                                            checked={paymentmode === "online"}
                                            onChange={handlePaymentChange}
                                        />

                                    </div>
                                    {paymentmode === "online" && (
                                        <div className="mt-3">
                                            <div className="mb-2">
                                                <label>Razorpay Key ID</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={razorpayKeyId}
                                                    onChange={(e) => setRazorpayKeyId(e.target.value)}
                                                    placeholder="rzp_live_xxxxxxxxxx"
                                                    style={{ fontFamily: 'monospace' }}
                                                />
                                            </div>
                                            <div className="mb-2">
                                                <label>Razorpay Secret</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={razorpaySecret}
                                                    onChange={(e) => setRazorpaySecret(e.target.value)}
                                                    placeholder="Your Razorpay Secret Key"
                                                    style={{ fontFamily: 'monospace' }}
                                                />
                                            </div>
                                            {razorpayWebhookUrl && (
                                                <div className="mt-3 p-2 border rounded">
                                                    <div className="d-flex align-items-center gap-2 mb-1">
                                                        <label className="fw-bold mb-0">Razorpay webhook URL</label>
                                                        <button
                                                            type="button"
                                                            className="btn btn-link p-0 border-0 align-middle lh-1 text-primary"
                                                            data-tooltip-id={RAZORPAY_WEBHOOK_URL_HINT_ID}
                                                            aria-label="Help: Razorpay webhook URL"
                                                        >
                                                            <i className="fas fa-info-circle" style={{ fontSize: '14px' }} aria-hidden />
                                                        </button>
                                                    </div>

                                                

                                                    <div className="d-flex flex-wrap gap-2 align-items-center mb-3">
                                                        <input
                                                            readOnly
                                                            className="form-control form-control-sm"
                                                            style={{ fontFamily: "monospace", fontSize: "12px" }}
                                                            value={razorpayWebhookUrl}
                                                        />
                                                        <MDBBtn size="sm" type="button" color="secondary" onClick={() => { copy(razorpayWebhookUrl); setcopyLink(true); }}>
                                                            Copy URL
                                                        </MDBBtn>
                                                    </div>

                                                    <div className="d-flex align-items-center gap-2 mb-1">
                                                        <label className="fw-bold mb-0">Webhook signing secret</label>
                                                        <button
                                                            type="button"
                                                            className="btn btn-link p-0 border-0 align-middle lh-1 text-muted"
                                                            data-tooltip-id={RAZORPAY_WEBHOOK_SECRET_HINT_ID}
                                                            aria-label="Help: webhook signing secret"
                                                        >
                                                            <i className="fas fa-question-circle" aria-hidden />
                                                        </button>
                                                    </div>

                                                    <p className="small text-muted mb-1">From Razorpay after saving the webhook. This is <em>not</em> the API Key Secret above.</p>

                                                    <input
                                                        type="password"
                                                        className="form-control"
                                                        value={razorpayWebhookSecretInput}
                                                        onChange={(e) => setRazorpayWebhookSecretInput(e.target.value)}
                                                        placeholder={hasRazorpayWebhookSecret ? "Secret saved — paste a new value to replace" : "Paste webhook signing secret from Razorpay"}
                                                        autoComplete="off"
                                                        style={{ fontFamily: "monospace" }}
                                                    />
                                                    <FieldHintTooltip
                                                        id={RAZORPAY_WEBHOOK_URL_HINT_ID}
                                                        content="Optional: Add this URL under Razorpay → Webhooks (same Test/Live as your keys). Paste the webhook signing secret below — this does not affect verified status. Verification is only from Pay yourself with valid Key ID and Secret. Without a webhook, your cron-style flow still applies."
                                                        place="bottom-end"
                                                        positionStrategy="fixed"
                                                        delayHide={150}
                                                        style={{ zIndex: 1090, maxWidth: 320 }}
                                                    />
                                                    <FieldHintTooltip
                                                        id={RAZORPAY_WEBHOOK_SECRET_HINT_ID}
                                                        content="From Razorpay after saving the webhook. This is not the API Key Secret above."
                                                        place="bottom-end"
                                                        positionStrategy="fixed"
                                                        delayHide={150}
                                                        style={{ zIndex: 1090, maxWidth: 280 }}
                                                    />
                                                </div>
                                            )}
                                            {(verificationStatus !== 'verified' || hasKeysChanged()) && (
                                                <>
                                                    {/* <p>Note: Send Rs.100/- to your account for confirmation.</p> */}
                                                    <RazorPayKeys
                                                        amount={totalAmount}
                                                        callback={(e, res) => handlePayment(e, res)}
                                                        gymid={gymId}
                                                        user={userdetails}
                                                        razorpayKeyId={razorpayKeyId}
                                                        razorpaySecret={razorpaySecret}
                                                    />
                                                </>
                                            )}

                                            {verificationStatus === 'verified' && !hasKeysChanged() && (
                                                <div className="text-success">
                                                    <i className="fas fa-check-circle me-2"></i>
                                                    Verified
                                                </div>
                                            )}

                                            {verificationStatus === 'failed ' && (
                                                <div className="text-danger">
                                                    <i className="fas fa-times-circle me-2"></i>
                                                    Verification failed
                                                </div>
                                            )}

                                            {verificationStatus === null && (
                                                <div className="text-warning">
                                                    <p>Note: Send Rs.100/- to your account for confirmation.</p>
                                                    <i className="fas fa-exclamation-circle me-2"></i>
                                                    Not verified
                                                </div>
                                            )}

                                        </div>

                                    )
                                    }
                                </div>
                            </MDBModalBody>
                            <MDBModalFooter className='pe-3 pb-3'>
                                <MDBBtn color='secondary' onClick={handleCloseBooking}>
                                    Close
                                </MDBBtn>
                                {paymentmode === "online" && <MDBBtn onClick={onSaveClassBookingUrl}
                                    disabled={!razorpayKeyId || !razorpaySecret || !hasChangesToSave() || hasKeysChanged()}
                                >Save</MDBBtn>}
                                {paymentmode === "offline" && <MDBBtn onClick={onSaveClassBookingUrl}>Save</MDBBtn>}
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>

                <MDBModal open={userQRCode} setOpen={setUserQRCode} show={userQRCode} setShow={setUserQRCode} tabIndex='-1'>
                    <MDBModalDialog>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Class Booking QR Code</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={userQRCodeHandler}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>

                                <div ref={modalBodyRef}>
                                    <center>
                                        <div>
                                            <QRCodeSVG style={{ width: '300px', height: '300px' }} value={currentdomain.status == 3 ? `https://${currentdomain.subdomain}.${mainDomain}/booking` : `${window.location.origin}/booking?id=${classbookingurl}`} />
                                        </div>
                                    </center>
                                </div>
                                <div className="mob-flex float-end mt-4">
                                    <MDBBtn className="ms-2" onClick={() => handlePrintPDF(currentdomain.status == 3 ? `https://${currentdomain.subdomain}.${mainDomain}/booking` : `${window.location.origin}/booking?id=${classbookingurl}`)}>
                                        Print
                                    </MDBBtn>
                                    <button className="ripple ripple-surface btn btn-secondary ms-2" onClick={userQRCodeHandler}>
                                        Close
                                    </button>
                                </div>
                            </MDBModalBody>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>

                <MDBModal show={paymentSetting} setShow={setPaymentSetting} open={paymentSetting} setOpen={setPaymentSetting} tabIndex='-1'>
                    <MDBModalDialog>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Payment Gatway</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={paymentSettingShow}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>
                                <PaymentGateway toggleShow={setPaymentMethods} paymentMethods={paymentMethods} from="class" />
                            </MDBModalBody>

                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>


                <MDBModal open={DigitalWaver} setOpen={setDigitalWaver} show={DigitalWaver} setShow={setDigitalWaver} tabIndex='-1'>
                    <MDBModalDialog>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Digital Waiver Form</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={() => { DigitalWaverShow(); }}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody className='pb-3'>
                                {DigitalWaver && <WaiverSettings toggleShow={DigitalWaverShow} data={WaiverForm} onSave={saveWaiverSettings} onbacktoStaff={onbacktoStaff} from="class" />}
                            </MDBModalBody>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>

                <MDBModal open={classSettings} setOpen={setClassSettings} show={classSettings} setShow={setClassSettings} tabIndex='-1'>
                    <MDBModalDialog>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Class Booking Settings</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={() => { classSettingsShow(); }}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody className='pb-3'>
                                {classSettings && <ClassBookingSettings
                                    toggleShow={classSettingsShow}
                                    onSettingsUpdate={fetchWaiverStatusForCard}
                                    from="class"
                                    showAlert={showAlert}

                                />}
                            </MDBModalBody>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>


                <MDBModal open={QRDigitalWaver} setOpen={setQRDigitalWaver} show={QRDigitalWaver} setShow={setQRDigitalWaver} tabIndex='-1'>
                    <MDBModalDialog>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>{WaiverForm.title ? WaiverForm.title : "Digital Waiver Form"}</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={QRDigitalWaverShow}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>


                                <div ref={modalBodyRef}>
                                    <center>
                                        <div>
                                            <QRCodeSVG style={{ width: '300px', height: '300px' }} value={link} />
                                        </div>
                                    </center>
                                </div>
                                <div className="mob-flex float-end mt-4" style={{ whiteSpace: 'nowrap' }}>
                                    <MDBBtn className="ms-2" onClick={handleCopyLink}>
                                        Copy Link
                                    </MDBBtn>
                                    <MDBBtn className="ms-2" onClick={() => handlePrintPDF(link)}>
                                        Print
                                    </MDBBtn>
                                    <MDBBtn className="ms-2" onClick={setQRDigitalWaverconfirmation}>
                                        Regenerate Link
                                    </MDBBtn>

                                    <button className="ripple ripple-surface btn btn-secondary ms-2" onClick={QRDigitalWaverShow}>
                                        Close
                                    </button>
                                </div>
                            </MDBModalBody>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>

                <MDBModal open={QRDigitalWaverconfirmation} setOpen={setQRDigitalWaverconfirmation} show={QRDigitalWaverconfirmation} setShow={setQRDigitalWaverconfirmation} tabIndex='-1'>
                    <MDBModalDialog>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>{WaiverForm.title ? WaiverForm.title : "Digital Waiver Form"}</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={QRDigitalWaverconfirmationShow}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>


                                <div ref={modalBodyRef}>
                                    <center>
                                        <div>By regenerating the <strong>link</strong>, the existing one sent to multiple members will be replaced and may no longer function. <br />Are you certain you wish to proceed with <strong>Regenerating</strong> the link?
                                        </div>
                                    </center>
                                </div>
                                <div className="mob-flex float-end mt-4">
                                    <MDBBtn className="ms-2" onClick={reGenerateLink}>
                                        Regenerate Link
                                    </MDBBtn>

                                    <button className="ripple ripple-surface btn btn-secondary ms-2" onClick={QRDigitalWaverconfirmationShow}>
                                        Close
                                    </button>
                                </div>
                            </MDBModalBody>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>

                <MDBModal open={cancellationModal} setOpen={SetCancellationModal} show={cancellationModal} setShow={SetCancellationModal} tabIndex='-1'>
                    <MDBModalDialog size='xl'>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Terms and Conditions</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={() => { canCellationModalShow(); }}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody className='pb-3'>
                                <FlexibleCancellationPolicy
                                    toggleShow={SetCancellationModal}
                                    onDetailsChange={handleDetailsChange}
                                    showAlert={showAlert}
                                />
                            </MDBModalBody>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>

                <MDBModal open={privacyModal} setOpen={SetPrivacyModel} show={privacyModal} setShow={SetPrivacyModel} tabIndex='-1'>
                    <MDBModalDialog size='xl'>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Privacy Policy</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={() => { PrivacyModalShow(); }}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody className='pb-3'>
                                <FlexiblePrivacyPolicy
                                    toggleShow={SetPrivacyModel}
                                    onDetailsChange={handleChangeDetails}
                                    showAlert={showAlert}

                                />
                            </MDBModalBody>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>

                <MDBModal open={announceModal} setOpen={setAnnounceModal} show={announceModal} setShow={setAnnounceModal} tabIndex='-1'>
                    <MDBModalDialog size='xl'>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Announcement</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={() => { PrivacyModalShow(); }}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody className='pb-3'>
                                <Announcements />
                            </MDBModalBody>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>
                <MDBAlert
                    color='success'
                    autohide
                    position='top-right'
                    delay={2000}
                    appendToBody
                    open={copyLink}
                    onClose={() => setcopyLink(false)}
                >Link copied to clipboard!
                </MDBAlert>
                <MDBAlert
                    color={Error2.includes("ailed") ? "danger" : "success"}
                    autohide
                    position='top-right'
                    delay={3000}
                    appendToBody
                    open={Error2 !== ""}
                    onClose={() => setError2("")}
                >
                    {Error2}
                </MDBAlert>
                <MDBAlert
                    color={errors ? "danger" : "success"}
                    autohide
                    position='top-right'
                    delay={4000}
                    appendToBody
                    open={Alerttxt != ""}
                    onClose={() => setAlerttxt("")}
                >
                    {Alerttxt}
                </MDBAlert>

            </SideNavClass >
        </>
    );
};

export default ClassBusinessInfo;